import React, { useEffect } from 'react'
import {
  setAuthAttemptFlag,
  useLoginSuccessDetection,
} from '@mc/authentication'
import { useUserInfo } from '@mc/user-info'
import { useStaticData } from '@mc/static-data-react'

/**
 * Component that detects successful logins for the CE-3448 experiment in the Next.js app
 * This is needed for non-members who get redirected to the Next.js home page after login
 */
export const LoginSuccessDetection = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()
  const { user, isLoading } = useUserInfo()

  // Consider user authenticated if they are logged in and user object exists
  const isAuthenticated = isLoggedIn && !isLoading && !!user

  useEffect(() => {
    if (!isAuthenticated && window.location.pathname === '/checkout') {
      setAuthAttemptFlag('signup')
    }
  }, [isAuthenticated])

  useLoginSuccessDetection({
    isAuthenticated,
    currentAuthType: user?.currentAuthType,
  })

  return <>{children}</>
}
